import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/home/Index.vue'
import CommonService from '../apis/CommonService'
// import Home from '../views/course/CourseList.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/course',
    name: 'CourseLayout',
    // component: App,
    children:[
      {
       path:'list',
       name: 'CourseList',
       component: ()=> import('../views/course/CourseList.vue'),
      },
      {
        path: 'info',
        name: 'CourseInfo',
        component: ()=> import('../views/course/CourseInfo.vue'),
      },
      {
        path: 'preview',
        name: 'CoursePreview',
        component: ()=> import('../views/course/VideoPreview.vue'),
      },
    ]
  },
  {
    path: '/courseDetail',
    name: 'CourseDetail',
    component: ()=> import('../views/course-detail/Index.vue'),
  },
  {
    path: '/coursePlay',
    name: 'CoursePlay',
    component: ()=> import('../views/course-detail/CoursePlay.vue'),
  },
  {
    path: '/pdfpreview',
    name: 'pdfpreview',
    component: ()=> import('../views/course-detail/pdfpreview.vue'),
  },
  {
    path: '/ucenter/index',
    name: 'UcenterIndex',
    component: ()=> import('../views/ucenter/Index.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    redirect: '/',
    // component: ()=> import('../views/Login.vue'),
  },
  // office 预览
  // {
  //   path: '/resource/office/preview',
  //   name: 'AiResourceOfficePreview',
  //   component: ()=> import('../views/ai_views/AiOfficeResourcePreview.vue'),
  // },
  {
    path: '/register',
    name: 'Register',
    redirect: '/',
    // component: ()=> import('../views/Register.vue'),
  },
  {
    path: '/forget',
    name: 'Forget',
    component: ()=> import('../views/Forget.vue'),
  }, 
  {
    path: '/download',
    name: 'Download',
    component: ()=> import('../views/downloads/Index.vue'),
    meta: {
      title: "资源下载-青只课堂",
      viewport:'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
    }
  },
  // {
  //   path: '/download_jiaoyushe.html',
  //   name: 'DownloadJump',
  //   component: ()=> import('../views/downloads/jump.vue'),
  // },
  {
    path: '/iprt_download',
    name: 'iprt_download',
    component: ()=> import('../views/downloads/iprt_Index.vue'),
    meta: {
      title: "IPRT下载-青只课堂",
      viewport:'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
    }
  },

  // AI相关
  {
    path: '/ai',
    name: 'Ai',
    // component: ()=> import('../views/ai/Index.vue'),
    children:[
      {
        path: '',
        name: 'AiHome',
        // redirect: '/ai/course',
        component: ()=> import('../views/ai_views/AiHome.vue'),
      },
      // /ai/mobile
      {
        path: 'mobile',
        name: 'AiMobile',
        component: ()=> import('../views/ai_views/AiHomeMible.vue'),
      },
      {
        path: 'course',
        name: 'AiCourseIndex',
        component: ()=> import('../views/ai_views/AiCourse.vue'),
      },
      // 不需要权限
      {
        path: 'course/info',
        name: 'AiCourseInfo',
        component: ()=> import('../views/ai_views/AiCourseInfo.vue'),
      },  
      // 需要登录网站，已激活用户
      {
        path: 'course/preview',
        name: 'AiCoursePreview',
        component: ()=> import('../views/ai_views/AiCoursePreview.vue'),
        // component: ()=> import('../views/ai_views/AiCoursePreviewMobile.vue'),
      },  
      // 教学资源
      {
        path: 'resource/list',
        name: 'AiResourceIndex',
        component: ()=> import('../views/ai_views/AiResourceInfo.vue'),
      },
      // office 预览
      {
        path: 'resource/office/preview',
        name: 'AiResourceOfficePreview',
        component: ()=> import('../views/ai_views/AiOfficeResourcePreview.vue'),
      },
      // 教学资源 word 预览
      {
        path: 'resource/word/preview',
        name: 'AiResourceWordPreview',
        component: ()=> import('../views/ai_views/AiWordResourcePreview.vue'),
      },

    ]

  },

  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component:  () => import(/* webpackChunkName: "not-found" */ '../views/404.vue'),
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部,平滑滚动
    if (savedPosition) {
      return savedPosition  
    }
    return { top: 0 }
  }
})

router.resolve({
  name: 'not-found',
  params: { pathMatch: ['not', 'found'] },
}).href // '/not/found'
router.beforeEach((to,from,next)=>{
 /* 路由发生变化修改页面meta */
 if(to.meta.viewport){
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    let oldViewport = document.getElementsByName('viewport')[0]
    //@ts-ignore
    meta.content = to.meta.viewport;
    meta.name = 'viewport'
    if(oldViewport){
      head[0].removeChild(oldViewport)
    }
    head[0].appendChild(meta)
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    //@ts-ignore
    document.title = to.meta.title;
  }
  next()

})

// 全局路由守卫：页面切换自动记录访问量
// App.vue 中记录，兼容 window.open 打开的新标签页无法触发路由守卫的问题
// router.afterEach((to) => {
//   const accessPath = to.fullPath // 当前页面路径（如 /home?a=1）

//   // 调用上报接口（异步不阻塞路由）
//   CommonService.recordAccess(accessPath).then(res => {
//     console.log('访问量上报结果：', res)
//   }).catch(err => {
//     console.error('访问量上报失败：', err)
//   })
// })
export default router
